import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lines"
export default class extends Controller {

  static values = { duration: Number };

  colors = [
    "#FFE870",
    "#EFAA83",
    "#B89EF9",
    "#66D6FC",
    "#E9F1A1",
    "#5CD17D"
  ];

  connect() {
    setTimeout(() => {
      this.createLines();
    }, 200);

    this.durationMultiplier = this.durationValue || (this.element.scrollHeight / 120);
    if (this.durationMultiplier < 2) this.durationMultiplier = 2;

    this.heightDivider = (this.element.scrollWidth / 600);

    if (this.heightDivider < 1.5) this.heightDivider = 1.5;
  }

  createLines = () => {
    let amount = Math.ceil(this.element.clientWidth / 35);

    if (amount < 10) amount = 10;

    for (let i = 0; i < amount; i++) {
      let line = document.createElement("div");
      line.className = "line";

      line.addEventListener('animationend', () => {
        this.setProperties(line);
      })

      this.setProperties(line);

      this.element.appendChild(line);
    }
  }

  getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  }

  setProperties = (el) => {
    let size = (Math.random() * 40) + 10;
    el.style.left = Math.random() * 90 + "%";
    el.style.top = 0;
    el.style.height = size + "px";
    el.style.width = (size / this.getRandomArbitrary(3, 6)) + "px";
    el.style.opacity = this.getRandomArbitrary(0.7, 1);
    //if (parseInt(this.getRandomArbitrary(0, 5)) == 0)
    el.style.filter = "blur(" + this.getRandomArbitrary(5, 10) + "px)";
    el.style.animationDelay = Math.random() * 2 + "s";
    el.style.animationDuration = Math.random() * this.durationMultiplier + 1.6 + "s";
    el.style.backgroundColor = this.colors[Math.floor(Math.random() * this.colors.length)];
    //el.style.borderColor = color[Math.floor(Math.random() * color.length)];
    //el.style.borderWidth = '3px'//Math.random() * 10 + "px";

    el.classList.remove('line--animation');
    void el.offsetWidth;
    el.classList.add('line--animation');
  }
}